import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { Assignment, FlashOn } from '@mui/icons-material';
import { formatPromptingLevel } from './utils';

const TaskAnalysisTab = ({ goalData }) => {
  return (
    <Grid container spacing={4}>
      {goalData?.TaskAnalysis?.TaskAnalysis?.length > 0 ? (
        goalData?.TaskAnalysis?.TaskAnalysis?.map((task, taskIndex) => (
          <Grid item xs={12} key={taskIndex}>
            <Paper elevation={0} variant='outlined' sx={{ p: 4, mb: 4, borderRadius: '20px', border: '1px solid #e0e0e0', position: 'relative', backgroundColor: '#ffffff', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease-in-out', '&:hover': { boxShadow: '0 8px 24px rgba(146, 145, 239, 0.15)', transform: 'translateY(-4px)' } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Assignment fontSize='medium' color='action' sx={{ mr: 2 }} />
                <Typography variant='h5' sx={{ fontWeight: 'bold', color: '#2c3e50' }}>
                  Task Analysis #{taskIndex + 1}
                </Typography>
              </Box>

              {task?.Steps?.length > 0 ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  {task.Steps.map((step, stepIndex) => (
                    <Paper key={stepIndex} variant='outlined' sx={{ p: 3, borderRadius: '16px', backgroundColor: '#fafafa', border: '1px solid #e0e0e0', transition: 'all 0.2s ease-in-out', '&:hover': { backgroundColor: '#f5f5f5', borderColor: '#9291ef' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant='h6' sx={{ fontWeight: 'bold', color: '#9291ef' }}>
                          Step {step.StepNumber}
                        </Typography>
                      </Box>

                      <Typography variant='body1' sx={{ mb: 3, fontSize: '1.1rem', lineHeight: 1.6 }}>
                        {step.Description}
                      </Typography>

                      {step.PromptingType && (
                        <Box sx={{ mt: 3 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <FlashOn fontSize='small' color='action' sx={{ mr: 1 }} />
                            <Typography variant='h6' sx={{ fontWeight: 600, color: '#6c757d' }}>
                              Prompting Type: {step.PromptingType}
                            </Typography>
                          </Box>

                          {step.PromptingValues && Object.keys(step.PromptingValues).length > 0 && (
                            <Grid container spacing={2}>
                              {Object.entries(step.PromptingValues).map(([key, value]) => (
                                <Grid item xs={6} sm={3} key={key}>
                                  <Paper variant='outlined' sx={{ p: 2, bgcolor: '#e9eaff', borderRadius: '12px', height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant='body2' color='text.secondary' gutterBottom sx={{ fontWeight: 600 }}>
                                      {formatPromptingLevel(key)}:
                                    </Typography>
                                    <Typography variant='body1' component='span' sx={{ fontWeight: 'bold', color: '#2c3e50' }}>
                                      {value}
                                    </Typography>
                                  </Paper>
                                </Grid>
                              ))}
                            </Grid>
                          )}
                        </Box>
                      )}
                    </Paper>
                  ))}
                </Box>
              ) : (
                <Paper variant='outlined' sx={{ p: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bgcolor: '#f8f9ff', borderRadius: '20px', border: '1px solid #e0e0e0' }}>
                  <Typography variant='h6' color='text.secondary' align='center' sx={{ fontWeight: 500 }}>
                    No steps available for this task analysis.
                  </Typography>
                </Paper>
              )}
            </Paper>
          </Grid>
        ))
      ) : (
        <Grid item xs={12}>
          <Paper variant='outlined' sx={{ p: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bgcolor: '#f8f9ff', borderRadius: '20px', border: '1px solid #e0e0e0' }}>
            <Typography variant='h6' color='text.secondary' align='center' sx={{ fontWeight: 500 }}>
              No task analysis available for this goal.
            </Typography>
          </Paper>
        </Grid>
      )}
    </Grid>
  );
};

export default TaskAnalysisTab;


